import { render, staticRenderFns } from "./FishSelector.vue?vue&type=template&id=c0dcddb8&"
import script from "./FishSelector.vue?vue&type=script&lang=ts&"
export * from "./FishSelector.vue?vue&type=script&lang=ts&"
import style0 from "./FishSelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports